import get from 'transmute/get';
// @ts-expect-error ts-migrate(2739) FIXME: Type '<T extends object | Iterable<any, any>>(subj... Remove this comment to see the full error message
export const getAuth = get('auth');